type MapboxContextItem = {
  id: string;
  short_code?: string;
  text?: string;
};

/**
 * City and state for a Mapbox place row. Mapbox `text` is only the matched
 * name ("Broadway"); city and region live on `context`.
 * State uses the region short code (`US-NY` → `NY`). When the feature itself
 * is the city, the city is not repeated.
 */
export function formatMapboxPlaceLocality(
  context: MapboxContextItem[] | undefined,
  featureText?: string,
): string | undefined {
  if (!context?.length) return undefined;

  const city = context.find((item) => item.id.startsWith('place'))?.text?.trim();
  const region = context.find((item) => item.id.startsWith('region'));
  const state = (region?.short_code?.replace(/^US-/i, '') || region?.text)?.trim();
  const name = featureText?.trim().toLowerCase();

  const showCity = !!city && city.toLowerCase() !== name;
  const showState = !!state && state.toLowerCase() !== name;

  if (showCity && showState) return `${city}, ${state}`;
  if (showCity) return city;
  if (showState) return state;
  return undefined;
}
